import { NGXLogger } from 'ngx-logger';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, of, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DEFINITIONS } from '../shared/app-definitions';
import { ParameterService } from './parameter.service';
import { ModuleData } from './module-data';

interface ProductIdEntry {
  id: string;
  lengths?: number[];
}

interface PartApiData {
  partid: string;
  cat: string;
  productids?: Array<string | ProductIdEntry>;
  phcodes: string[];
  link: string;
  lang: {
    de_DE: { title: string; descr: string };
    en_US: { title: string; descr: string };
  };
}

   // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Local DEV environment: Load parts
   // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Local DEV environment: Load parts
// import allTestParts from './../_DEBUG/allParts.DC-AE.json';
   // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Local DEV environment: Load parts
   // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Local DEV environment: Load parts

@Injectable({
  providedIn: 'root'
})

export class ModuleDataService {

  // data of selected module
  private moduleDataSelected: ModuleData | undefined;

  // observables
  private bSubjectServiceIsReady = new BehaviorSubject(false);
  private serviceIsReady = false;

  // config-api: all available organisations and parts
  private allParts = new Map();
  private readonly urlGeneratorApiOrgs = DEFINITIONS.urlGeneratorApi + '/organisations';
  private readonly generatorSwitchMinInputLength = 1;

  private logger = inject(NGXLogger);
  private http = inject(HttpClient);
  private parService = inject(ParameterService);

  constructor() {
    this.logger.info('(module-data.service) => constructor()');
    this.initModuleData();

   // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Local DEV environment: Load parts
   // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Local DEV environment: Load parts
// this.allParts.set('DC-AE', allTestParts);
   // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Local DEV environment: Load parts
   // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! Local DEV environment: Load parts
  }

  public get ModuleDataLoaded(): boolean {
    return (this.moduleDataSelected !== undefined);
  }

  //
  // Read part data from config api (ecad.generator.server)
  //
  private initModuleData() {
    // get all orgs
    this.http.get<object[]>(this.urlGeneratorApiOrgs).subscribe({
      next: (orgs: Array<object & { orgid: string }>) => {
        // check for orgs
        this.logger.info('(module-data.service) Organisations in DB => ' + JSON.stringify(orgs));
        if (orgs.length === 0) {
          // service is ready
          this.logger.info('(module-data.service) No Organisations found! - service is ready!');
          this.serviceIsReady = true;
          this.bSubjectServiceIsReady.next(true);
          return;
        }

        // get all urls to query parts
        const urlsAllParts: Array<string> = [];
        orgs.forEach((organisation) => {
          const urlPartsOfOrg = DEFINITIONS.urlGeneratorApi + '/organisations/' + organisation.orgid + '/parts';
          urlsAllParts.push(urlPartsOfOrg);
          this.logger.info('(module-data.service) Organisation Url => ' + urlPartsOfOrg);
        });

        // get all parts of all orgs
        // const allPartsObservables = urlsAllParts.map(url => this.http.get<object>(url).catch(() => of(null)));
        const allPartsObservables = urlsAllParts.map(url => this.http.get<object[]>(url).pipe(catchError((err) => of(err))));
        forkJoin(allPartsObservables)
          .subscribe(partsOfOrgs => {
            let orgIndex = 0;
            partsOfOrgs.forEach(parts => {
              this.logger.info('==============================================================');
              this.logger.info('== Load Parts from ORGANISATION => ' + orgs[orgIndex].orgid);
              this.logger.info('==============================================================');
              this.logger.info('Number of found parts: ' + parts.length);
              this.allParts.set(orgs[orgIndex].orgid, parts);
              let partIndex = 0;
              parts.forEach((part: object & { partid: string; phcodes: unknown }) => {
                partIndex++;
                this.logger.info(partIndex + '. part:' + part.partid + ', phcodes:' + JSON.stringify(part.phcodes));
              });
              orgIndex++;
            });
            if (orgIndex === partsOfOrgs.length) {
              // service is ready
              this.serviceIsReady = true;
              this.bSubjectServiceIsReady.next(true);
              return;
            }
          });
      },
      // error handling (get all orgs)
      error: (error) => {
        //
        // ToDo: Add Splunk Log
        //
        this.logger.error('(module-data.service) Error get all Organisations => ' + error.message);
        this.serviceIsReady = true;
        this.bSubjectServiceIsReady.next(true);
      }
    });
  }


  public getModuleData(moduleId?: string): Observable<ModuleData> {
    this.logger.info('(module-data.service) Enter => getModuleData(moduleId?: string), moduleId: ' + moduleId);
    return this.getModuleDataBestMatch(moduleId);
  }

  public getModuleDataBestMatch(moduleId?: string): Observable<ModuleData> {
    this.logger.info('(module-data.service) Enter => getModuleDataBestMatch(moduleId?: string), moduleId: ' + moduleId);

    return new Observable<ModuleData>((subscriber) => {
      // check if data already available
      if (this.moduleDataSelected) {
        if (moduleId) {
          subscriber.next(this.getModuleOfId(moduleId));
          subscriber.complete();
          return;
        }
        subscriber.next(this.moduleDataSelected);
        subscriber.complete();
        return;
      }

      this.logger.info('(module-data.service) Subscribe => bSubjectServiceIsReady');
      this.bSubjectServiceIsReady.subscribe(serviceIsReady => {
        this.logger.info('(module-data.service) bSubjectServiceIsReady, Result => ' + serviceIsReady);
        if (this.serviceIsReady) {
          this.logger.info('(module-data.service) bSubjectServiceIsReady, All Module data is loaded!');
          this.moduleDataSelected = this.getModuleOfId(moduleId ? moduleId : this.parService.calledTypeCode);
          subscriber.next(this.moduleDataSelected);
          subscriber.complete();
        } else {
          this.logger.info('(module-data.service) bSubjectServiceIsReady, Module data - NOT yet loaded!');
        }
      });
      return;
    });
  }

  public getModuleDataAllMatches(moduleId: string): Observable<ModuleData[]> {
    this.logger.info('(module-data.service) Enter => getModuleDataAllMatches(moduleId: string), moduleId: ' + moduleId);

    return new Observable<ModuleData[]>((subscriber) => {
      if (this.serviceIsReady) {
        subscriber.next(this.getAllModulesOfId(moduleId));
        subscriber.complete();
        return;
      }

      this.logger.info('(module-data.service) Subscribe => bSubjectServiceIsReady');
      this.bSubjectServiceIsReady.subscribe(serviceIsReady => {
        this.logger.info('(module-data.service) bSubjectServiceIsReady, Result => ' + serviceIsReady);
        if (this.serviceIsReady) {
          this.logger.info('(module-data.service) bSubjectServiceIsReady, All Module data is loaded!');
          subscriber.next(this.getAllModulesOfId(moduleId));
          subscriber.complete();
        } else {
          this.logger.info('(module-data.service) bSubjectServiceIsReady, Module data - NOT yet loaded!');
        }
      });
      return;
    });
  }

  public getGeneratorSwitchMatches(input: string, orgid?: string): Observable<ModuleData[]> {
    this.logger.info('(module-data.service) Enter => getGeneratorSwitchMatches(input: string), input: ' + input);

    return new Observable<ModuleData[]>((subscriber) => {
      if (this.serviceIsReady) {
        subscriber.next(this.getGeneratorSwitchModulesOfInput(input, orgid));
        subscriber.complete();
        return;
      }

      this.logger.info('(module-data.service) Subscribe => bSubjectServiceIsReady');
      this.bSubjectServiceIsReady.subscribe(serviceIsReady => {
        this.logger.info('(module-data.service) bSubjectServiceIsReady, Result => ' + serviceIsReady);
        if (this.serviceIsReady) {
          this.logger.info('(module-data.service) bSubjectServiceIsReady, All Module data is loaded!');
          subscriber.next(this.getGeneratorSwitchModulesOfInput(input, orgid));
          subscriber.complete();
        } else {
          this.logger.info('(module-data.service) bSubjectServiceIsReady, Module data - NOT yet loaded!');
        }
      });
      return;
    });
  }

  //
  // Get module with forwarded moduleId (of org)
  //
  public getModuleOfId(id: string, orgid?: string): ModuleData {
    let partData: ModuleData = {
      moduleId: '', cat: '',  phcodes: [], link: '', title: '', description: '', image: ''
    };
    // check orgid
    if (!orgid) {
      orgid = 'DC-AE';
    }
    // get part
    const partsOfOrg = this.allParts.get(orgid);
    if (partsOfOrg) {
      for (const part of partsOfOrg) {
        // use the longest matching string
        if (id.startsWith(part.partid) && (part.partid.length > partData.moduleId.length)) {
          partData = this.createPartData(orgid, part);
        }
      }
    }
    return partData;
  }

  public getAllModulesOfId(id: string, orgid?: string): ModuleData[] {
    const partDataList: ModuleData[] = [];

    // check orgid
    if (!orgid) {
      orgid = 'DC-AE';
    }

    // get all matching parts (sorted by longest match first)
    const partsOfOrg = this.allParts.get(orgid);
    if (partsOfOrg) {
      for (const part of partsOfOrg) {
        if (id.startsWith(part.partid)) {
          partDataList.push(this.createPartData(orgid, part));
        }
      }
      partDataList.sort((a, b) => b.moduleId.length - a.moduleId.length);
    }

    return partDataList;
  }

  public getGeneratorSwitchModulesOfInput(input: string, orgid?: string): ModuleData[] {
    const normalizedInput = input.trim().toUpperCase();

    if (normalizedInput.length < this.generatorSwitchMinInputLength) {
      return [];
    }

    if (!orgid) {
      orgid = 'DC-AE';
    }

    const partsOfOrg = this.allParts.get(orgid);
    if (!partsOfOrg) {
      return [];
    }

    const allModules: ModuleData[] = [];
    for (const part of partsOfOrg) {
      allModules.push(this.createPartData(orgid, part));
    }

    const matches = allModules.filter(m => this.getPrefixMatchLength(normalizedInput, m.moduleId) > 0);

    matches.sort((a, b) => {
      const diff = this.getPrefixMatchLength(normalizedInput, b.moduleId)
        - this.getPrefixMatchLength(normalizedInput, a.moduleId);

      return diff !== 0 ? diff : a.moduleId.localeCompare(b.moduleId);
    });

    return matches;
  }

  private getPrefixMatchLength(input: string, moduleId: string): number {
    const normalizedInput = input.trim().toUpperCase();
    const normalizedModuleId = moduleId.trim().toUpperCase();

    const hasPrefixMatch = normalizedModuleId.startsWith(normalizedInput)
      || normalizedInput.startsWith(normalizedModuleId);

    if (!hasPrefixMatch) {
      return 0;
    }

    return Math.min(normalizedInput.length, normalizedModuleId.length);
  }

  //
  // Get all modules of a category (and org)
  //
  public getModulesOfCategory(category?: string, orgid?: string): ModuleData[] {
    const partsOfCat: ModuleData[] = [];

    // check orgid
    if (!orgid) {
      orgid = 'DC-AE';
    }
    // get parts
    const partsOfOrg = this.allParts.get(orgid);
    if (partsOfOrg) {
      for (const part of partsOfOrg) {
        if (part.cat === category) {
          const part2 = this.createPartData(orgid, part);
          partsOfCat.push(part2);
        }
      }
    }
    return partsOfCat;
  }

  //
  // Convert part data from json file format to PartData format
  //
  private createPartData(orgid: string, part: PartApiData) {
    const language = this.parService.language;
    const partData: ModuleData = {
      moduleId: '', cat: '', phcodes: [], link: '', title: '', description: '', image: '', productIdRules: []
    };
    partData.moduleId = part.partid;
    partData.cat = part.cat;
    partData.productIdRules = this.normalizeProductIdRules(part.productids);
    partData.phcodes = part.phcodes;
    partData.link = part.link;
    partData.image = DEFINITIONS.urlGeneratorApi + '/organisations/' + orgid + '/parts/' + part.partid + '/image';

    if (language === DEFINITIONS.deDeLanguage) {
      partData.title = part.lang.de_DE.title;
      partData.description = part.lang.de_DE.descr;
    } else {
      partData.title = part.lang.en_US.title;
      partData.description = part.lang.en_US.descr;
    }
    return partData;
  }

  private normalizeProductIdRules(entries?: Array<string | ProductIdEntry>): Array<{ id: string; lengths: number[] }> {
    if (!Array.isArray(entries)) {
      return [];
    }

    // Merge duplicate product ids into one rule and collect all valid lengths for that id.
    const mergedRuleLengthsById = new Map<string, Set<number>>();

    entries.forEach((entry) => {
      // Support both legacy string entries (id only) and object entries (id + lengths).
      const id = (typeof entry === 'string' ? entry : entry.id || '').trim().toUpperCase();

      if (id.length === 0) {
        // Ignore invalid/empty ids from backend data.
        return;
      }

      // Keep only positive integer lengths; everything else is treated as invalid input.
      const lengths = typeof entry === 'string'
        ? []
        : (Array.isArray(entry.lengths)
          ? entry.lengths.filter((value) => Number.isInteger(value) && value > 0)
          : []);

      const existingLengths = mergedRuleLengthsById.get(id) ?? new Set<number>();
      // Union lengths across duplicate ids.
      lengths.forEach((length) => existingLengths.add(length));
      mergedRuleLengthsById.set(id, existingLengths);
    });

    const rules = Array.from(mergedRuleLengthsById.entries())
      .map(([id, lengths]) => ({
        id,
        lengths: Array.from(lengths).sort((a, b) => a - b)
      }));

    // Use the most specific prefix first when searching matching productid rules.
    rules.sort((a, b) => b.id.length - a.id.length);
    return rules;
  }
}

